<template>
  <content-layout :title="title" :headImage="headImage" :tabs="tabs" v-model="activeTab" :spin-show="spinShow">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div slot="slogan">
    </div>
    <div class="activity-item mgui-container" slot="/attend">
      <div class="filter-row" style="overflow:hidden" v-if="$store.state.userInfo.role!=5">
        <div style="float:right">
          <!-- <Button @click="preMonth"><Icon type="chevron-left"></Icon> 上一月</Button>
          <span style="font-size:14px;padding: 0 10px">{{year}}年{{month}}月</span>
          <Button @click="nextMonth">下一月 <Icon type="chevron-right"></Icon></Button> -->
        </div>
        <div class="filter-row-item">
          筛选：
          <Input v-model="filterItem.username" placeholder="姓名" clearable style="width:120px;" @on-enter="fetchDataUsers"></Input>
          <Cascader v-model="filterItem.department_id" placeholder="选择项目组" style="width:140px;display:inline-block;margin-right:5px" :data="$store.state.department" change-on-select></Cascader>
          <Button type="error" @click="fetchDataUsers" icon="md-search">筛选</Button>
          <Divider type="vertical" v-if="$menu.isPower('attend', 'post')"/>
          <Button type="info" @click="uploadModal=true" v-if="$menu.isPower('attend', 'post')" icon="md-cloud">上传考勤表</Button> 
          <Divider type="vertical"/>
          <Button type="success" @click="uploadSalaryModal=true" v-if="$menu.isPower('attend', 'salary')" icon="logo-usd">上传薪资表</Button> 
          <Divider type="vertical"/>
          <Button @click="exportSalary" v-if="$menu.isPower('attend', 'export_salary')" icon="ios-download">导出薪资</Button>
          &nbsp;
        </div>
      </div>
      <div v-if="$store.state.userInfo.role!=5">
        <div style="text-align:center;margin-bottom:20px;" v-if="isMobile">
          <Button icon="md-arrow-round-back" @click="preMonth"></Button>
          <span style="margin:0 10px;font-size:14px;">{{lastYear + '/' + lastMonth + '/ 21  -- ' + this.year + ' / ' + this.month + ' / 20'}}</span>
          <Button icon="md-arrow-round-forward" @click="nextMonth"></Button>
        </div>
        <Table border :columns="isMobile?attendMobileCol:attendCol" :loading="tableloading" class="attend-box" :data="users.data"></Table>
        <Page :page-size="users.per_page" :total="users.total" class="pager" @on-change="pagerChange"></Page>
      </div>
      <div v-else>
        <div style="text-align:center">
          <Button icon="md-arrow-round-back" @click="preMonth"></Button>
          <span style="margin:0 10px;font-size:14px;">{{lastYear + '年' + lastMonth + '月 21 日 -- ' + this.year + ' 年 ' + this.month + ' 月 20 日' + '考勤'}}</span>
          <Button icon="md-arrow-round-forward" @click="nextMonth"></Button>
        </div>
        <div style="padding: 10px 0"><Button @click="fetchSalary(users.data[0].user_id)" long>查看薪资单</Button></div>
        <div style="margin-bottom:20px">
          <div class="attend-item" style="padding: 10px;width:100%;border-bottom:1px solid #eee;"  v-for="(item, ind) in users.days" :key="ind" :class="(item.week_index === 0 || item.week_index === 6) ? ' sxr' : ''">
            <div style="float:right;color:#aaa">{{item.week}}</div>
            <div style="float:left;">{{item.day}}</div>
            <div style="text-align:center" v-if="users.data.length>0&&users.data[0].content&&users.data[0].content[ind]">
              <i :class="'cicon icon-'+users.data[0].content[ind].mark"></i> {{attendTitle[users.data[0].content[ind].mark]}}
            </div>
            <div style="text-align:center" v-else>--</div>
          </div>
        </div>
        <Button @click="fetchSalary(users.data[0].user_id)" long>查看薪资单</Button>
      </div>
      <Modal v-model="mobileAttendVisible" title="考勤明细">
        <div style="margin-bottom:20px">
          <div class="attend-item" style="padding: 10px;width:100%;border-bottom:1px solid #eee;"  v-for="(item, ind) in users.days" :key="ind" :class="(item.week_index === 0 || item.week_index === 6) ? ' sxr' : ''">
            <div style="float:right;color:#aaa">{{item.week}}</div>
            <div style="float:left;">{{item.day}}</div>
            <div style="text-align:center" v-if="users.data.length>0&&users.data[0].content&&users.data[0].content[ind]">
              <i :class="'cicon icon-'+users.data[0].content[ind].mark"></i> {{attendTitle[users.data[0].content[ind].mark]}}
            </div>
            <div style="text-align:center" v-else>--</div>
          </div>
        </div>
      </Modal>
      <Modal :title="this.currentUserName + ' ' + this.year+' 年 '+this.month+' 月 薪资明细'" v-model="salaryModal" width="700">
        <Row class="salary-list">
          <div class="bd" v-if="salary.content">
            <Col class="salary-item" :span="(item.title=='备注'||item.title=='应扣合计'||item.title=='应发合计'||item.title=='本月实发薪资'||item.title=='可报销合计')?24:6"
              v-for="(item, ind) in salary.content" :key="ind"
              :class="{'highlight': isHighlight(item.title), 'bz':item.title=='备注', 'gray': (item.title=='应扣合计'||item.title=='应发合计')}">
              <strong>{{item.title}}：</strong><span>{{item.value}}</span>
            </Col>
            <Col class="salary-item highlight" :span="24" v-if="salary.attach.length>0"><strong>其他费用</strong></Col>
            <template v-for="(item, ind) in salary.attach">
              <Col class="salary-item" :span="24"  v-if="salary.attach.length>0" :key="ind">
                <strong :key="ind">{{item.remarks}}：</strong>
                <span :key="ind">{{item.value}}</span>
              </Col>
            </template>
            <Col class="salary-item highlight" :span="24" v-if="salary.attach.length>0"><strong>本月薪资总额：</strong><span>{{salary.total}}</span></Col>
          </div>
          <div class="nodata" v-else>
            {{salaryTip||'--请选择查询日期--'}}
          </div>
          <div>
            <Alert type="warning" style="width:90%;margin:0 auto" show-icon>
              <Icon type="ios-lightbulb-outline" size="30" slot="icon"></Icon>
              <div slot="desc">
                <p>1、每月出差补贴部分提供的发票和实际产生的请分开填写报销单，不要合在一张报销单上；</p>
                <p>2、本月<span style="color:#f00">可报销部分</span>，请大家尽快提供相应的冲抵发票，以免耽误报销，不提供发票的也需要填写报销单，电子报销单统一发到邮箱：<span style="color:#f00">zjyumai@126.com</span> ，财务没收到报销单及发票的补助将延后发放；</p>
              </div>
            </Alert>
          </div>
          <div style="text-align:center;padding:10px;"><a href="javascript:void(0)" @click="$parent.$parent.boardVisible=true">如有疑问？请留言。</a></div>
        </Row>
        <div slot="footer"></div>
      </Modal>
      <Modal
          v-model="uploadModal"
          title="更新考勤"
          width="340"
          :mask-closable="false"
          @on-cancel="uploadCancel">
          <div>
            <div style="text-align:left;margin-bottom:10px">
              <h6>选择日期: </h6>
              <DatePicker type="month" v-model="attendMonth" @on-change="attendDateChange" placeholder="选择年月" style="width:100%"></DatePicker>
            </div>
            <Upload
              ref="upload"
              :show-upload-list="false"
              :on-success="handleSuccess"
              :format="['xls','xlsx']"
              :max-size="10048"
              :data="{file_type:'attend_table'}"
              :headers="uploadHeaders"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              :disabled="isEditTimeEnd"
              type="drag"
              v-show="uploadState==0"
              :action="uploadApiPath"
               class="upload-item" :class="{'disabled': isEditTimeEnd}" style="margin:0">
                <div style="width:100%;padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52"></Icon>
                  <p>选择考勤表</p>
                </div>
            </Upload>
            <div v-show="uploadState==1" style="text-align:center">正在上传...</div>
            <Alert v-show="uploadState>=2" style="text-align:left">考勤表已上传 <Button type="default" :disabled="uploadState!=2" @click="uploadState=0" size="small">重新选择</Button></Alert>

          </div>
          <div slot="footer">
            <Button type="error" size="large" :disabled="uploadState!=2 || isEditTimeEnd || !uploadResult.file_path" @click="uploadOk">确定更新考勤</Button>
            <Tag v-if="isEditTimeEnd && attendMonth" style="float:left" type="border" color="red">已截止，无法更新</Tag>
            <Tag v-show="uploadState==3" type="border" style="float:left" >正在更新，请稍等...</Tag>
        </div>
      </Modal>
      <Modal
          v-model="uploadSalaryModal"
          title="工资条"
          width="340"
          :mask-closable="false"
          @on-cancel="uploadCancel">
          <div>
            <Upload
              ref="upload"
              :show-upload-list="false"
              :on-success="handleSalarySuccess"
              :format="['xls','xlsx']"
              :max-size="10048"
              :data="{file_type:'salary_table'}"
              :headers="uploadHeaders"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              type="drag"
              v-show="uploadSalaryState==0"
              :action="uploadApiPath"
               class="upload-item" style="margin:0">
                <div style="width:100%;padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>选择薪资表</p>
                </div>
            </Upload>
            <div v-show="uploadSalaryState==1" style="text-align:center">正在上传...</div>
            <div v-show="uploadSalaryState==2" style="text-align:left">
              <h6>上传成功，请选择日期！ </h6>
              <DatePicker type="month" v-model="attendSalaryMonth" placeholder="选择年月" style="width:100%"></DatePicker>
            </div>
            <div v-show="uploadSalaryState==3" style="text-align:center">正在更新，请稍等</div>
          </div>
          <div slot="footer">
            <Button type="default" size="large" :disabled="uploadSalaryState!=2" @click="uploadSalaryState=0">重新选择</Button>
            <Button type="error" size="large" :disabled="uploadSalaryState!=2" @click="uploadSalaryOk">确定发送工资条</Button>
        </div>
      </Modal>
    </div>
    <div class="activity-item mgui-container" slot="/attend/base">
      <users-attend-base v-if="activeTab=='/attend/base'"></users-attend-base>
    </div>
    <div class="activity-item mgui-container" slot="/attend/count">
      <users-attend-count v-if="activeTab=='/attend/count'"></users-attend-count>
    </div>
    <div class="activity-item mgui-container" slot="/attend/salary">
      <users-attend-salary v-if="activeTab=='/attend/salary'"></users-attend-salary>
    </div>
  </content-layout>
</template>


<script>
  import {fetch, put, post} from '../fetch/api'
  // import DoubleCalendar from '../components/DoubleCalendar'
  import calendars from '../util/calendars.js'
  // import fullCalendar from 'vue-fullcalendar'
  // const modelName = 'user'
  const attendTitle = {
    'cq': '出勤',
    'cc': '出差',
    'jb': '加班',
    'sx': '实习',
    'px': '培训(闲)',
    'px2': '培训(忙)',
    'jq': '假期',
    'nx': '年休',
    'hcj': '婚假、产假',
    'bj': '病假',
    'sj': '丧假',
    'shij': '事假',
    'kg': '旷工',
    '离职': '离职',
    'lz': '离职',
    'zp': '招聘',
    '招聘': '招聘'
  }
  // function prefixInteger (num, n) {
  //   return (Array(n).join(0) + num).slice(-n)
  // }

  const invertKeyValues = obj =>
    Object.keys(obj).reduce((acc, key) => {
      acc[obj[key]] = key
      return acc
    }, {})
  
  export default {
    name: 'usersAttend',
    components: {
      // fullCalendar,
      UsersAttendBase: resolve => { require(['../components/UsersAttendBase'], resolve) },
      UsersAttendSalary: resolve => { require(['../components/UsersAttendSalary'], resolve) },
      UsersAttendCount: resolve => { require(['../components/UsersAttendCount'], resolve) },
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      let token = localStorage.getItem('token')
      let date = new Date()
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m

      return {
        userId: 0,
        title: '考勤',
        tabs: [
          {'title': '考勤/薪资', 'key': '/attend', 'visible': true},
          {'title': '薪资汇总', 'key': '/attend/count', 'visible': this.$menu.isPower('attend', 'template_salary')},
          {'title': '薪资管理', 'key': '/attend/salary', 'visible': this.$menu.isPower('attend', 'template_salary')},
          {'title': '基础数据', 'key': '/attend/base', 'visible': this.$menu.isPower('attend', 'template_salary')}
          // {'title': '操作日志', 'key': 'logs', 'visible': true}
        ],
        activeTab: '/attend',
        groupData: [],
        tableloading: false,
        spinShow: true,
        curDate: y + '/' + m,
        params: {
          date: y + '/' + m
        },
        year: y,
        month: Number(m),
        lastMonth: '',
        lastYear: '',
        formItem: {},
        isOthers: false,
        mobileAttendVisible: false,
        attendTabs: 'attend',
        attendTitle: attendTitle,
        filterItem: {
          username: null,
          status: 2,
          department_id: []
        },
        page: {
          total: 0,
          page: 0
        },
        // items: [
        //   {label: '岗位工资', value: '$jbgz', color: 'blue'},
        //   {label: '岗位津贴', value: '$gwjt', color: 'blue'},
        //   {label: '通信补贴', value: '$txbt', color: 'blue'},
        //   {label: '交通补贴', value: '$jtbt', color: 'blue'},
        //   {label: '电脑补贴', value: '$dnbt', color: 'blue'},
        //   {label: '加班工资', value: '$jbgz', color: 'blue'},
        //   // {label: '应发合计', value: '应发合计'},
        //   {label: '薪资扣税', value: '$xzks', color: 'blue'},
        //   {label: '代缴社保', value: '$djsb', color: 'blue'},
        //   {label: '公积金扣款', value: '$gjjkk', color: 'blue'},
        //   {label: '其他应扣', value: '$qtkk', color: 'blue'},
        //   // {label: '应扣合计', value: '应扣合计'},
        //   {label: '管理绩效', value: '$gljx', color: 'blue'},
        //   {label: '考核绩效', value: '$kqjx', color: 'blue'},
        //   {label: '出差补贴标准', value: '$ccbtbz', color: 'blue'},
        //   {label: '出差补贴', value: '$ccbt', color: 'blue'},
        //   {label: '其他费用', value: '$qtfy', color: 'blue'}
        // ],
        salary: [],
        selectAttend: '',
        users: {
          per_page: 15,
          total: 0,
          days: [],
          weeks: []
        },
        currentUserName: '',
        headImage: '/static/images/bg/kq.png',
        calendarVisible: false,
        events: [],
        attends: [],
        salaryTip: null,
        selectUserId: '',
        attendCount: [],
        attendMobileCol: [
          {
            title: '姓名',
            width: 100,
            render: (h, params) => {
              return h('span', params.row.username)
            }
          },
          {
            title: '考勤',
            align: 'center',
            render: (h, params) => {
              if (!this.$menu.isPower('attend', 'view_salary') && Number(this.$store.state.userInfo.id) !== params.row.user_id) {
                return h('span', {style: {color: '#ccc', cursor: 'not-allowed'}}, '查看')
              }
              return h('a', {
                on: {
                  click: () => {
                    this.mobileAttendVisible =true
                  }
                }
              }, '查看')
            }
          },
          {
            title: '薪资',
            align: 'center',
            render: (h, params) => {
              if (!this.$menu.isPower('attend', 'view_salary') && Number(this.$store.state.userInfo.id) !== params.row.user_id) {
                return h('span', {style: {color: '#ccc', cursor: 'not-allowed'}}, '查看')
              }
              return h('a', {
                on: {
                  click: () => {
                    this.currentUserName = params.row.username
                    this.fetchSalary(params.row.user_id)
                  }
                }
              }, '查看')
            }
          },
        ],
        attendCol: [
          {
            title: '姓名',
            width: 100,
            // fixed: 'left',
            render: (h, params) => {
              return h('span', params.row.username)
            }
          },
          {
            title: '考勤',
            align: 'center',
            renderHeader: (h) => {
              return h('div', [
                h('Button', {props: {icon: 'md-arrow-round-back', size: 'small'}, on: {click: this.preMonth}}),
                h('span', {style: 'margin:0 10px', fontSize: '16px'}, this.lastYear + '年' + this.lastMonth + '月 21 日 -- ' + this.year + ' 年 ' + this.month + ' 月 20 日' + '考勤'),
                h('Button', {props: {icon: 'md-arrow-round-forward', size: 'small'}, on: {click: this.nextMonth}})
              ])
            },
            children: [
              {
                minWidth: 800,
                render: (h, params) => {
                  if (params.row.content !== 'undefined' && params.row.content) {
                    var attends = params.row.content
                    if (typeof attends == 'string') attends = JSON.parse(params.row.content)
                    var cols = []
                    var _t = this
                    let endDate = new Date(params.row.year + '/' + params.row.month + '/25 00:00:00').getTime()
                    let now = new Date().getTime()
                    for (var key in attends) {
                      if (attends.hasOwnProperty(key)) {
                        var date = attends[key].date
                        cols.push(
                          h('Tooltip', {class: 'attend-item', props: {content: attendTitle[attends[key].mark]}},
                            [
                              h('span', {
                                class: 'cicon icon-' + attends[key].mark,
                                style: 'cursor:pointer',
                                attrs: {date: date, data: attends[key].mark, 'index': params.row._index, key: key},
                                on: {
                                  click: function (e) {
                                    if (now > endDate && _t.$store.state.userInfo.group_id !== 1 && _t.$store.state.userInfo.role !== 4) {
                                      _t.$Message.error('已截止，无法修改')
                                    } else {
                                      _t.editAttend(e.target)
                                    }
                                  }
                                }
                              }),
                              h('span', {style: {fontSize: '12px', color: '#ccc'}}, attendTitle[attends[key].mark])
                            ]
                          )
                        )
                      }
                    }
                    return h('div', {class: 'attend-list'}, cols)
                  } else {
                    return h('div', {style: {color: '#ccc'}}, '暂无考勤数据')
                  }
                },
                renderHeader: (h) => {
                  let dateCols = []
                  for (let k in this.users.days) {
                    if (this.users.days.hasOwnProperty(k)) {
                      var classname = (this.users.days[k].week_index === 0 || this.users.days[k].week_index === 6) ? ' sxr' : ''
                      dateCols.push(
                        h('div', {class: 'attend-item' + classname}, [
                          h('span', {style: {fontSize: '14px'}}, this.users.days[k].day),
                          h('span', {style: {fontSize: '12px', color: '#ccc'}}, this.users.days[k].week)
                        ])
                      )
                    }
                  }
                  return h('div', {class: 'attend-list'}, dateCols)
                }
              }
            ]
          },
          {
            title: '薪资',
            width: 80,
            align: 'center',
            render: (h, params) => {
              if (!this.$menu.isPower('attend', 'view_salary') && Number(this.$store.state.userInfo.id) !== params.row.user_id) {
                return h('span', {style: {color: '#ccc', cursor: 'not-allowed'}}, '查看')
              }
              return h('a', {
                on: {
                  click: () => {
                    this.currentUserName = params.row.username
                    this.fetchSalary(params.row.user_id)
                  }
                }
              }, '查看')
            }
          },
          {
            title: '状态',
            // fixed: 'right',
            align: 'center',
            width: 120,
            render: (h, params) => {
                let date = new Date(params.row.year + '/' + params.row.month + '/25 00:00:00')
                let now = new Date()
                if (now > date && this.$store.state.userInfo.group_id !== 1 && this.$store.state.userInfo.role !== 4) {
                  return h('Tooltip', {props: {content: '超过截止日期'}}, [
                    h('span', {props: {size: 'small', disabled: true}, style: 'margin-right:5px'}, '已截止')
                  ])
                } else {
                  if (this.$store.state.userInfo.group_id === 1 || this.$store.state.userInfo.role === 4) {
                    return h('div', [
                      h('div', {props: {size: 'small'}, style: 'margin-right:5px'}, '可修改')
                    ])
                  } else {
                    return h('div', [
                      h('div', {props: {size: 'small'}, style: 'margin-right:5px'}, '可修改'),
                      h('div', {props: {size: 'small'}, style: 'margin-right:5px;color:#999'}, '每月25日截止')
                    ])
                  }
                }
            }
          }
        ],
        countStr: [],
        attendMonth: null,
        attendSalaryMonth: null,
        salaryModal: false,
        uploadModal: false,
        uploadSalaryModal: false,
        isEditTimeEnd: true,
        uploadList: [],
        uploadState: 0,
        uploadSalaryState: 0,
        uploadResult: {file_path: null},
        uploadSalaryResult: {},
        uploadApiPath: '/api/users/upload/attend',
        uploadHeaders: {
          'Authorization': `Bearer ${token}`
        },
        viewType: 'list'
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      },
      selectUserId (val, old) {
        if (val !== old) {
          this.events = []
        }
      },
      month () {
        this.fetchDataUsers()
      },
      attendTabs (val, old) {
        if (val === old) return false
        this.$router.push({'path': 'attend?action=' + val})
        this.userChange()
        if (val === 'salary') this.fetchSalary()
      }
    },
    mounted () {
      this.preMonth()
      this.isOthers = this.$menu.isPower('attend', 'others')
      // this.$EventCalendar.toDate(this.curDate)
      this.$store.dispatch('setDepartment', false)
      this.spinShow = false
      // this.fetchDataUsers()
      this.routeChange(this.$route)
    },
    computed: {
      isMobile () {
        return document.body.clientWidth <= 640
      }
    },
    methods: {
      routeChange (route) {
        let action = route.params.action
        let query = route.query
        if (action === undefined) {
          this.activeTab = '/attend'
          this.$router.push({'path': '/attend'})
          // this.isOthers = this.$menu.isPower('attend', 'others')
          // this.$EventCalendar.toDate(this.curDate)
          // this.$store.dispatch('setDepartment', false)
          // this.spinShow = false
        } else if (action === 'base') {
          this.activeTab = '/attend/base'
          this.$router.push({'path': '/attend/base'})
        } else if (action === 'count') {
          this.activeTab = '/attend/count'
          this.$router.push({'path': '/attend/count', query: query})
        } else if (action === 'salary') {
          this.activeTab = '/attend/salary'
          this.$router.push({'path': '/attend/salary', query: query})
        }
        this.spinShow = false
      },
      fetchSalary (uid) {
        // let time = new Date(this.params.date)
        // let year = time.getFullYear()
        // let month = time.getMonth() + 1
        // let date = year + '-' + month
        this.salaryModal = true
        let date = this.year + '-' + this.month
        let params = {time: date}
        // console.log()
        this.salary = []
        this.salaryTip = '正在查询'
        fetch(`users/attend/salary/${uid}`, {params: params}).then(res => {
          if (res.status === 'ok' && res.result !== null) {
            this.salaryTip = ''
            this.salary = res.result
            this.salary.content = JSON.parse(this.salary.content)

            this.$router.push({path: '/attend', query: params})
          } else {
            this.salaryTip = '--暂无该月薪资记录--'
          }
        }).catch(() => {
          this.spinShow = false
        })
      },
      formatAttendCount () {
        let str = ''
        let date = this.params.date
        let uid = this.selectUserId
        if (this.attendCount[uid] === undefined) return ''
        for (let i in this.attendCount[uid][date]) {
          str = str + this.attendCount[uid][date][i].title + ' : ' + this.attendCount[uid][date][i].count + ' 天  '
        }
        this.$set(this.countStr, uid, str)
      },
      monthAttendCount (item) {
        let data = []
        let content = JSON.parse(item.content)
        let uid = item.user_id
        this.attendCount[uid] = []
        this.countStr[uid] = ''
        for (let k in content) {
          let mark = content[k].mark
          let title = attendTitle[mark]
          if (data[mark] === undefined) {
            data[mark] = {'count': 1, 'title': title}
          } else {
            let num = data[mark].count
            data[mark] = {'count': num + 1, 'title': title}
          }
        }
        let month = item.month < 10 ? '0' + item.month : item.month
        this.$set(this.attendCount[uid], item.year + '/' + month, data)
        setTimeout(() => {
          this.formatAttendCount()
        }, 400)
      },
      editAttend (target) {
        var date = target.getAttribute('date')
        var index = target.getAttribute('index')
        var key = target.getAttribute('key')
        var attends = invertKeyValues(attendTitle)
        this.selectAttend = attendTitle[this.users.data[index].attends[key].mark]

        this.$Modal.confirm({
          title: '修改' + date + '考勤',
          width: 500,
          render: (h) => {
            var items = []
            for (var k in attendTitle) {
              if (attendTitle.hasOwnProperty(k)) {
                items.push(h('Radio', {style: 'width:20%;padding:10px;display:inline-block', props: {label: attendTitle[k]}}))
              }
            }
            return h('RadioGroup', {
              props: {
                value: this.selectAttend
              },
              on: {
                'on-change': (val) => {
                  this.selectAttend = val
                }
              },
              style: 'padding-top:20px'}, items)
          },
          onOk: () => {
            let id = this.users.data[index].attend.id
            let content = JSON.parse(JSON.stringify(this.users.data[index].attends))
            content[key].mark = attends[this.selectAttend]
            put(`users/attend/save/${id}`, {content: JSON.stringify(content)}).then(res => {
              if (res.status === 'success') {
                this.users.data[index].attends[key].mark = attends[this.selectAttend]
                this.$Notice.info({title: res.msg})
              } else {
                this.$Notice.error({title: res.msg})
              }
            })
          }
        })
      },
      formatAttend (item) {
        // let data = []
        let content = JSON.parse(item.content)

        for (let k in content) {
          let mark = content[k].mark
          this.events.push({
            date: content[k].date,
            title: attendTitle[mark],
            class: 'cicon icon-' + mark
          })
        }
        // this.events.push(data)
      },
      isHighlight (title) {
        let tit = ['本月实发薪资', '可报销合计']
        return tit.indexOf(title) >= 0
      },
      handleDayChange () {
        // console.log(val)
      },
      handleMonthChange () {
        this.events = []
        this.userChange()
      },
      userChange () {
        if (this.attendTabs === 'attend') this.fetchData()
        if (this.attendTabs === 'salary') this.fetchSalary()
      },
      getCurMonth () {
        // let $title = document.querySelector('.cal-header .title')
        // let title = $title.innerHTML
        // return title
      },
      preMonth () {
        let month = this.month - 1
        if (month === 0) this.year = this.year - 1
        this.month = month === 0 ? 12 : month
        this.setLastYear()
      },
      nextMonth () {
        let month = this.month + 1
        if (month > 12) this.year = this.year + 1
        this.month = month > 12 ? 1 : month
        this.setLastYear()
        // this.$EventCalendar.nextMonth()
      },
      setLastYear () {
        this.lastMonth = this.month - 1
        this.lastYear = this.year
        if (this.lastMonth === 0) {
          this.lastMonth = 12
          this.lastYear = this.lastYear - 1
        }
      },
      pagerChange (page) {
        this.page.page = page
        this.fetchDataUsers()
        this.routerChange()
      },
      routerChange () {
        let query = JSON.parse(JSON.stringify(this.filterItem))
        if (query.username === '' || query.username === null) delete query.username
        query.page = this.page.page
        this.$router.push({path: '/attend', query: query})
      },
      fetchDataUsers () {
        let params = JSON.parse(JSON.stringify(this.filterItem))
        params.page = this.page.page
        if (params.department_id !== null) params.department_id = JSON.stringify(params.department_id)
        this.spinShow = true
        this.$store.state.loadingState = true
        params.year = this.year
        params.month = this.month
        this.users.data = []
        this.tableloading = true
        fetch(`users/attends`, {params: params}).then(res => {
          if (res.status === 'ok') {
            this.users = res.result
            if (this.users.data.length == 1) {
              this.users.data[0].content = JSON.parse(this.users.data[0].content)
            }
            if (this.users.data.length > 0) {
              this.$set(this.page, 'total', res.result.total - 1)
              this.users.days = calendars.days(this.year, this.month)
              // this.users.weeks = calendars.weeks(this.year, this.month, 21)
              // let weeks = calendars.weeks(this.year, this.month, 21)
              // this.selectUserId = this.users[0].id
              // this.fetchData()
              // if (this.attendTabs === 'salary') this.fetchSalary()
              // this.$router.push({path: 'users?status=' + params.status})
              // query.department_id = JSON.stringify(query.department_id)
            }
          }
          this.tableloading = false
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
        this.$store.state.loadingState = false
      },
      fetchData () {
        // if (this.userId === 0) return
        // this.events = []
        this.spinShow = true
        this.attends = []
        this.attendCount = []
        this.countStr[this.selectUserId] = ''
        this.params.date = this.year + '/' + this.month
        fetch(`users/attend/${this.selectUserId}`, {params: this.params}).then(res => {
          if (res.status === 'ok') {
            if (res.result.length > 0) {
              this.attends = res.result
              this.formatAttend(this.attends[0])
              this.monthAttendCount(this.attends[0])
            }
          }
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      },
      uploadCancel () {
        this.uploadState = 0
      },
      uploadOk () {
        if (!this.uploadResult.file_path) {
          this.$Message.error('请上传考勤表')
          return
        }
        if (this.attendMonth === '' || this.attendMonth === null) {
          this.$Message.error('请选择日期')
          return
        }
        this.uploadState = 3
        let path = this.uploadResult.file_path
        post('users/attend/table', {'file_path': path, 'date': this.attendMonth}).then(res => {
          if (res.status === 'ok') {
            this.$Message.success('更新成功')
            this.uploadState = 0
            this.attendMonth = ''
            this.uploadModal = false
            this.fetchDataUsers()
          }
        })
      },
      uploadSalaryOk () {
        if (this.attendSalaryMonth === '' || this.attendSalaryMonth === null) {
          this.$Message.error('请选择日期')
        } else {
          this.uploadSalaryState = 3
          let path = this.uploadSalaryResult.file_path
          post('users/attend/table', {'type': 'salary', 'file_path': path, 'date': this.attendSalaryMonth}).then(res => {
            if (res.status === 'ok') {
              this.$Message.success('更新成功')
              this.uploadSalaryState = 0
              this.attendSalaryMonth = ''
              this.uploadSalaryModal = false
              this.fetchDataUsers()
            }
          })
        }
      },
      handleSalarySuccess (res) {
        if (res.status === 'ok') {
          this.uploadSalaryState = 2
          this.uploadSalaryResult = res.result
          // this.attendSalaryMonth = res.time
        }
      },
      handleSuccess (res) {
        if (res.status === 'ok') {
          this.uploadState = 2
          this.uploadResult = res.result
          // this.attendMonth = res.time
        }
      },
      handleFormatError (file) {
        this.$Notice.warning({
          title: '上传错误',
          desc: '您上传的文件可能有误【' + file.name + '】, 请选择xls/xlsx文件.'
        })
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: '文件太大',
          desc: '文件  ' + file.name + ' 太大了, 请不要超过 2M.'
        })
      },
      handleBeforeUpload () {
        const check = this.uploadList.length < 5
        if (!check) {
          this.$Notice.warning({
            title: 'Up to five pictures can be uploaded.'
          })
        }
        return check
      },
      attendDateChange (date) {
        if (this.$store.state.userInfo.group_id === 1 || this.$store.state.userInfo.role === 4) {
          this.isEditTimeEnd = false
          return
        }
        date = new Date(date + '-25 00:00:00')
        let now = new Date()
        if (now > date) {
          this.isEditTimeEnd = true
        } else {
          this.isEditTimeEnd = false
        }
      },
      exportSalary () {
        let params = JSON.parse(JSON.stringify(this.filterItem))
        if (params.department_id !== null) params.department_id = JSON.stringify(params.department_id)
        params.year = this.year
        params.month = this.month
        post('/users/export/salary', params).then(res => {
          if (res.status === 'success') {
            this.$Message.success('请求成功，请稍等...')
            window.location.href = this.apiPath + `export_salary?cry=${res.cry}&time=${new Date().getTime()}`
          } else {
            this.$Message.error(res.msg)
          }
        })
      }
    }
  }
</script>
<style>
  .cicon:after{
    content: '√';
    width: 20px;
    text-align: center;
    border-radius: 10px;
    background: #2d8cf0;
    font-size: 10px;
    z-index: 10;
    display: inline-block;
    font-family: cursive;
  }
  /*.cicon{opacity: .6}*/
  .cicon span,.cicon{
    /*border-color: #2d8cf0 !important;*/
    color: #fff;
  }
  .cicon.icon-cc:after{
    content: '☆';
    padding: 0 3px;
    background: #f29543;
  }
  .cicon p{
    color: #333 !important;
  }
  .cicon.icon-jb:after{
    content: '+';
    background: #f00;
  }
  .cicon.icon-sx:after{
    content: '□';
    padding: 0 2px;
    background: #8c7d67;
  }
  .cicon.icon-px:after{
    content: '￥';
    padding: 0 4px;
    background: #a05600;
  }
  .cicon.icon-px2 p{
    color: #a05600 !important;
  }
  .cicon.icon-px2:after{
    content: '$';
    background: #a05600;
  }
  .cicon.icon-jq:after{
    content: '≈';
    background: #19be6b;
  }
  .cicon.icon-nx:after{
    content: '⊙';
    padding: 0 4px;
    background: #7600ff;
  }
  .cicon.icon-hcj:after{
    content: '凸';
    padding: 0 2px;
    background: #fd00ca;
  }
  .cicon.icon-bj:after{
    content: '凹';
    padding: 0 2px;
    background: #000;
  }
  .cicon.icon-sj:after{
    content: '∞';
    padding: 0 4px;
    background: #000;
  }
  .cicon.icon-shij:after{
    content: '×';
    padding: 0 5px;
    background: #143ced;
  }
  .cicon.icon-kg:after{
    content: '－';
    padding: 0 5px;
    background: #143ced;
  }
  .cicon.icon-招聘:after{
    content: 'J';
    padding: 0 5px;
    background: #069eb1;
  }
  .cicon.icon-离职:after{
    content: 'Q';
    padding: 0 5px;
    background: #069eb1;
  }
  .cicon.icon-zp:after{
    content: 'J';
    padding: 0 5px;
    background: #069eb1;
  }
  .cicon.icon-lz:after{
    content: 'Q';
    padding: 0 5px;
    background: #069eb1;
  }
  .__vev_calendar-wrapper .cal-wrapper{
    width: 100%;
    /*border: 1px solid #ddd;*/
    border-radius: 10px;
    padding: 30px 20px;
    margin-bottom: 20px;
  }
  .item .is-event{
    border-color:#999 !important;
  }
  .cicons-wrapper{display: none}
  .__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item .is-today{
    background: #f00 !important
  }
  .attend-list{display:flex;white-space: nowrap;justify-content: space-between;min-width: 800px;}
  .attend-item{flex:1}
  .attend-item.sxr{background: #dbe8f9;}
  .attend-item span{display: block;text-align: center;max-width: 30px;overflow: hidden;}
  .attend-box th .ivu-table-cell{display: block;}
  .upload-item.disabled .ivu-upload-drag:hover{border-color:#ccc;cursor:no-drop;}
</style>
<style scoped>
  .upload-item .ivu-icon-ios-cloud-upload{color:#39f}
  .upload-item.disabled .ivu-icon-ios-cloud-upload{color:#ccc}
  .salary-list .bd{border-top: 1px solid #eee;border-left: 1px solid #eee;overflow: hidden;zoom:1;margin-bottom: 20px;}
  .salary-list h2{border-bottom: 1px solid #eee;margin-bottom:20px;padding:0 0 10px;}
  .salary-item{border-bottom:1px solid #eee;border-right: 1px solid #eee}
  .salary-item strong{background:#f7f7f7;width:90px;padding:10px 0;display: inline-block;text-align:right;font-size:12px;margin-right: 10px}
  .salary-item.highlight{color:#c60;background-color: #fbddbe;}
  .salary-item.highlight strong{background-color: #fbddbe;}
  .salary-item.gray{color:green;background-color: #fff;}
  .salary-item.gray strong{background-color: #fff;}
  .attend-lists{padding-right:10px;}
  .attend-lists li{
    padding: 10px;
    border-bottom: 1px solid #eee;
    font-size: 16px;
  }
  .attend-lists li:first-child{border-radius: 10px 10px 0 0}
  .attend-lists li:last-child{border-radius: 10px}
  .attend-lists li.select{
    background: #f7f7f7;
  }
  .attend-lists li.is-select{background: #eee;}
  @media (max-width: 640px) {
    .attend-lists li{
    padding: 6px;
    font-size: 12px;
  }
    /*.attend-lists {background: #fff;padding:0;border-radius: 10px;}
    .attend-lists-col{height:100%;width:100%;padding:15px;position: fixed;top:0;left:0;background: rgba(0,0,0,.6);z-index: 10;overflow-y: scroll;}*/
  }
</style>
